document.addEventListener("DOMContentLoaded", function () {
    
    var metaRobots = document.querySelector('meta[name="robots"][content="noindex, follow"]');

    if (metaRobots) {
        var canonicalTag = document.querySelector('link[rel="canonical"]');
        if (canonicalTag) {
            canonicalTag.parentNode.removeChild(canonicalTag);
        }
    }
});

document.addEventListener('DOMContentLoaded', function () {
    var searchIcon = document.querySelector('.header__icon--search');
    var closeButton = document.querySelector('.search-modal__close-button');
    var searchForm = document.querySelector('.search-modal__form');

    function handleClick() {
        if (searchForm.hasAttribute('open')) {
        } else {
        }
    }

    searchIcon.addEventListener('click', handleClick);
    closeButton.addEventListener('click', handleClick);
});

// product upsell variant buttons - поддержка товаров с опциями и без
(function () {
  // Функция для генерации URL изображения с нужным размером (Shopify CDN)
  function getSizedImageUrl(src, size) {
    if (!src) return src;
    // const url = new URL(src);
    // return url.toString();
    return src;
  }

  const upsellItems = document.querySelectorAll('.product__upsell_item');

  upsellItems.forEach(upsellItem => {
    const buttons = upsellItem.querySelectorAll('.product__upsell_item_variant');
    const checkbox = upsellItem.querySelector('input[name="product__upsell"]');
    const variantsJson = upsellItem.dataset.variants;

    if (!checkbox || !variantsJson) {
      console.warn('Missing checkbox or variants for:', upsellItem);
      return;
    }

    const variants = JSON.parse(variantsJson);

    // Если нет опций (один вариант), ничего не делаем — value уже в Liquid
    if (!buttons.length) {
      return; // Skip further processing for single-variant products
    }

    // Функция для обновления чекбокса и изображения
    function updateCheckbox() {
      const selectedOptions = {};
      const groups = upsellItem.querySelectorAll('.option-group');

      // Собираем выбранные значения
      groups.forEach(group => {
        const groupName = group.dataset.group;
        const optionIndex = parseInt(group.dataset.optionIndex) + 1; // option1, option2, ...
        const activeButton = group.querySelector('.product__upsell_item_variant.active');
        if (activeButton) {
          selectedOptions[`option${optionIndex}`] = activeButton.dataset.value;
        }
      });

      // Ищем вариант
      const matchingVariant = variants.find(variant => {
        return Object.keys(selectedOptions).every(key => {
          return variant[key] === selectedOptions[key];
        });
      });

      if (matchingVariant) {
        checkbox.value = matchingVariant.id;

        // Обновляем только основное изображение, если есть featured_image
        if (matchingVariant.featured_image && matchingVariant.featured_image.src) {
          const src = matchingVariant.featured_image.src;
          const mainImg = upsellItem.querySelector('.product__upsell_image');
          if (mainImg) {
            mainImg.src = getSizedImageUrl(src, 300);
          }
        }
      } else {
        console.warn('No matching variant found for:', selectedOptions);
        checkbox.value = variants[0].id; // Fallback на первый вариант
        // Для fallback тоже обновляем только основное изображение первого варианта
        if (variants[0].featured_image && variants[0].featured_image.src) {
          const src = variants[0].featured_image.src;
          const mainImg = upsellItem.querySelector('.product__upsell_image');
          if (mainImg) {
            mainImg.src = getSizedImageUrl(src, 300);
          }
        }
      }
    }

    // Обработчик клика
    buttons.forEach(btn => {
      btn.addEventListener('click', () => {
        const groupContainer = btn.closest('.option-group');
        if (groupContainer) {
          groupContainer.querySelectorAll('.product__upsell_item_variant').forEach(sibling => {
            sibling.classList.remove('active');
          });
          btn.classList.add('active');
          const multilangColor = document.querySelector('.product__upsell_item_variants').dataset.group
          // Обновление отображения выбранного цвета для 'Kolor'

          if (groupContainer.dataset.group === multilangColor) {
            console.log(1)
            const optionValueDiv = groupContainer.querySelector('.option_value');
            if (optionValueDiv) {
              optionValueDiv.textContent = btn.dataset.value;
            }
          }
        }

        updateCheckbox();
      });
    });

    // Инициализация только для товаров с опциями
    if (buttons.length) {
      updateCheckbox();
    }
  });
})();

document.addEventListener('DOMContentLoaded', function () {
    // Получаем все элементы продуктов
    const productItems = document.querySelectorAll('#Slider .grid__item');
    const productArray = Array.from(productItems);

    // Проверяем, есть ли доступные продукты
    if (productArray.length === 0) {
        console.warn("Нет доступных продуктов для отображения!");
        return; // Если нет продуктов, выходим
    }

    // Перемешиваем массив с продуктами
    for (let i = productArray.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [productArray[i], productArray[j]] = [productArray[j], productArray[i]];
    }

    // Скрываем все элементы перед показом
    productArray.forEach(item => {
        item.style.display = "none"; // Скрываем все карточки
    });

    // Отображаем ровно 4 случайных продукта
    for (let i = 0; i < Math.min(4, productArray.length); i++) {
        productArray[i].style.display = "list-item"; // Показываем элемент
    }
});

// product upsell variant buttons
// (function () {
//     if (document.querySelector('.product__upsell_item_variant')) {
//         const buttons = document.querySelectorAll('.product__upsell_item .product__upsell_item_variant')

//         buttons.forEach(el => {
//             el.addEventListener('click', () => {
//                 const checkbox = el.closest('.product__upsell_item').querySelector('input[type="checkbox"]')
//                 buttons.forEach(element => {
//                     element.classList.remove('active')
//                 })
//                 el.classList.add('active')
//                 if (el.closest('.product__info-wrapper')) {
//                     checkbox.value = el.dataset.id                    
//                 }
//             })
//         })
//     }
// })();
// product upsell variant buttons

// video reviews
(function () {
    if (document.querySelector('.video_reviews')) {
        const videoFullScreenContainer = document.querySelector('.video_reviews__container_full');
        const closeFullscreen = videoFullScreenContainer.querySelector('.close');
        let isVisible = false; // Флаг видимости слайдера

        closeFullscreen.addEventListener('click', () => {
            videoFullScreenContainer.classList.remove('active');
            videoFullScreenContainer.querySelectorAll('video').forEach(video => {
                video.pause();
                video.currentTime = 0.1;
                video.load();
            });
            swiper.autoplay.start();
        });

        const videoPlay = (slider, full) => {
            if (!isVisible) return; // Если слайдер не виден, не воспроизводим видео

            slider.el.querySelectorAll('video').forEach(video => {
                video.pause();
            });

            const video = slider.slides[slider.activeIndex].querySelector('video');
            if (video) {
                video.currentTime = 0.2;
                video.play();
                if (!full) {
                    video.muted = true;
                }
            }
        };

        const swiper2 = new Swiper('.video_reviews__container_full', {
            loop: true,
            direction: 'vertical',
            slidesPerView: 1,
            mousewheel: {
                enabled: true,
                thresholdTime: 300,
            },
            on: {
                transitionEnd: function () {
                    if (this.el.classList.contains('active')) {
                        videoPlay(this, true);
                    }
                }
            }
        });

        const swiper = new Swiper('.video_reviews__container', {
            loop: true,
            effect: "coverflow",
            grabCursor: true,
            centeredSlides: true,
            slidesPerView: "auto",
            autoplay: {
                delay: 5000,
                disableOnInteraction: false,
            },
            coverflowEffect: {
                rotate: 0,
                stretch: 0,
                depth: 200,
                modifier: 1,
                slideShadows: true,
            },
            thumbs: {
                swiper: swiper2
            },
            navigation: {
                nextEl: document.querySelector('.video_reviews__container_wr .swiper-button-next'),
                prevEl: document.querySelector('.video_reviews__container_wr .swiper-button-prev'),
            },
            on: {
                transitionEnd: function () {
                    videoPlay(this);
                },
                tap: function () {
                    videoFullScreenContainer.classList.add('active');
                    videoPlay(swiper2, true);
                    this.autoplay.stop();
                },
                init: function () {
                    this.slides.forEach(element => {
                        element.querySelectorAll('video').forEach(video => {
                            video.currentTime = 0.2;
                        });
                    });
                }
            }
        });

        // === Intersection Observer для управления autoplay и воспроизведением видео ===
        const observer = new IntersectionObserver(entries => {
            entries.forEach(entry => {
                isVisible = entry.isIntersecting;

                if (isVisible) {
                    swiper.autoplay.start();
                    videoPlay(swiper);
                } else {
                    swiper.autoplay.stop();
                    swiper.slides.forEach(slide => {
                        slide.querySelectorAll('video').forEach(video => {
                            video.pause();
                        });
                    });
                }
            });
        }, { threshold: 0.5 });

        observer.observe(document.querySelector('.video_reviews__container'));
    }
})();
// video reviews


// toggle popup
(function () {
    if (document.querySelector('.popup_overlay')) { 
        document.addEventListener('DOMContentLoaded', function() {
            const openPopupBtn = document.querySelectorAll('.openPopup');
            const closePopupBtn = document.querySelectorAll('.popup_close_btn');
            const popupOverlay = document.querySelectorAll('.popup_overlay');
        
            openPopupBtn.forEach(btn => {
                btn.addEventListener('click', function() {
                    
                    const targetId = btn.dataset.popup
                    document.querySelector(`.popup_overlay#${targetId}`).classList.add('show');
                    document.querySelector('html').classList.add('overflow-hidden')
                });
            })
        
            closePopupBtn.forEach(el => {
                el.addEventListener('click', function() {
                    el.closest('.popup_overlay').classList.remove('show');
                    document.querySelector('html').classList.remove('overflow-hidden')
                });
            })
        
            popupOverlay.forEach(element => {
                element.addEventListener('click', function(event) {
                    if (event.target === element) {
                        popupOverlay.forEach(el => {
                            el.classList.remove('show');
                        })
                        document.querySelector('html').classList.remove('overflow-hidden')
                    }
                });
            }); 
        });
        
    }
})();
// toggle popup



// toggle class in upsell item
(function () {
    const inputs = document.querySelectorAll('.product__upsell input')
  
    inputs.forEach(input => {
      input.addEventListener('change', () => {
        const upsellItem = input.closest('.product__upsell_item')
        if (input.checked) {
          upsellItem.classList.add('active')
        } else {
          upsellItem.classList.remove('active')
        }
      })
    })
  })();
  // toggle class in upsell item

// image comparison
(function () {
    if (document.querySelector('.comparison')) {
        let commonProgress = 0.5; // Глобальное значение прогресса для всех ползунков
        const blocks = document.querySelectorAll('.comparison__block');
    
        const isElementInViewport = (el) => {
          const rect = el.getBoundingClientRect();
          return (rect.top < window.innerHeight && rect.bottom > 0);
        };
    
        blocks.forEach(block => {
          const divisor = block.querySelector(".comparison__before"),
                slider = block.querySelector(".comparison__range");
          let animationFrame;
          let direction = 1;
          let isInteracted = false;
          let progress = 0.5;
          let lastTime = performance.now();
          const speed = 0.0004; // скорость анимации
    
          const easeInOut = (t) => {
            return t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t;
          };
    
          const moveDivisor = () => { 
            divisor.style.width = slider.value + "%";
          };
    
          const animateSlider = (timestamp) => {
            if (isInteracted || !isElementInViewport(block)) {
              cancelAnimationFrame(animationFrame);
              animationFrame = null;
              return;
            }
            const deltaTime = timestamp - lastTime;
            lastTime = timestamp;
            progress += (speed * deltaTime) * direction;
            if (progress >= 1) {
              progress = 1;
              direction = -1;
            } else if (progress <= 0) {
              progress = 0;
              direction = 1;
            }
            const value = 10 + easeInOut(progress) * 80;
            slider.value = value;
            moveDivisor();
            commonProgress = progress; // синхронизируем с глобальным значением
            animationFrame = requestAnimationFrame(animateSlider);
          };
    
          slider.addEventListener('input', () => {
            isInteracted = true;
            moveDivisor();
            cancelAnimationFrame(animationFrame);
          });
    
          // При отпускании мыши/касания сбрасываем progress в общее значение
          slider.addEventListener('mouseup', () => {
            isInteracted = false;
            progress = commonProgress;
            lastTime = performance.now();
            animateSlider(lastTime);
          });
    
          slider.addEventListener('touchend', () => {
            isInteracted = false;
            progress = commonProgress;
            lastTime = performance.now();
            animateSlider(lastTime);
          });
    
          slider.addEventListener('touchstart', () => {
            isInteracted = true;
            cancelAnimationFrame(animationFrame);
          });
    
          slider.addEventListener('touchmove', () => {
            isInteracted = true;
            cancelAnimationFrame(animationFrame);
          });
    
          window.addEventListener('scroll', () => {
            if (!isInteracted && isElementInViewport(block) && !animationFrame) {
              lastTime = performance.now();
              animateSlider(lastTime);
            }
          });
    
          animateSlider(lastTime);
        });

        document.querySelectorAll('.comparison__range').forEach(rangeInput => {
            rangeInput.addEventListener('touchstart', function(e) {
                e.preventDefault();
                const touch = e.targetTouches[0];
                const value = Math.round((touch.pageX - this.getBoundingClientRect().left) / this.offsetWidth * 100);
                this.value = value;
                const event = new Event('input', { bubbles: true });
                this.dispatchEvent(event);
            });

            rangeInput.addEventListener('touchmove', function(e) {
                e.preventDefault();
                const touch = e.targetTouches[0];
                const value = Math.round((touch.pageX - this.getBoundingClientRect().left) / this.offsetWidth * 100);
                this.value = value;
                const event = new Event('input', { bubbles: true });
                this.dispatchEvent(event);
            });
        });
        // скроллбар
        const container = document.querySelector(".comparison__wrapper");
        const scrollbar = document.querySelector(".comparison__scrollbar");
        const thumb = document.querySelector(".comparison__scrollbar-thumb");

        if (container && scrollbar && thumb) {
        // Обновление позиции thumb в зависимости от scrollLeft контейнера
        const updateThumb = () => {
            const scrollableWidth = container.scrollWidth - container.clientWidth;
            const scrollRatio = container.scrollLeft / scrollableWidth;
            const maxThumbMove = scrollbar.clientWidth - thumb.clientWidth;
            thumb.style.transform = `translateX(${scrollRatio * maxThumbMove}px)`;
        };

        // Перемещение контейнера по клику по скроллбару
        const moveScrollbar = (clientX) => {
            const rect = scrollbar.getBoundingClientRect();
            const offsetX = clientX - rect.left;
            const clickRatio = offsetX / scrollbar.clientWidth;
            const scrollableWidth = container.scrollWidth - container.clientWidth;
            container.scrollLeft = clickRatio * scrollableWidth;
            updateThumb();
        };

        let isDragging = false;
        let dragStartX = 0;
        let initialScrollLeft = 0;

        const startDrag = (clientX) => {
            isDragging = true;
            dragStartX = clientX;
            initialScrollLeft = container.scrollLeft;
        };

        const duringDrag = (clientX) => {
            if (!isDragging) return;
            const deltaX = clientX - dragStartX;
            const scrollbarWidth = scrollbar.clientWidth - thumb.clientWidth;
            const scrollableWidth = container.scrollWidth - container.clientWidth;
            const scrollDelta = deltaX * (scrollableWidth / scrollbarWidth);
            container.scrollLeft = initialScrollLeft + scrollDelta;
            updateThumb();
        };

        const endDrag = () => {
            isDragging = false;
        };

        // Обработчики для мыши
        thumb.addEventListener("mousedown", (e) => {
            e.stopPropagation();
            thumb.style.cursor = "grabbing";
            startDrag(e.clientX);
        });
        document.addEventListener("mousemove", (e) => {
            duringDrag(e.clientX);
        });
        document.addEventListener("mouseup", () => {
            thumb.style.cursor = "grab";
            endDrag();
        });

        // Обработчики для touch
        thumb.addEventListener("touchstart", (e) => {
            e.stopPropagation();
            const touch = e.touches[0];
            startDrag(touch.clientX);
        });
        thumb.addEventListener("touchmove", (e) => {
            const touch = e.touches[0];
            duringDrag(touch.clientX);
            e.preventDefault();
        });
        thumb.addEventListener("touchend", endDrag);

        // Обработка клика по пустому месту скроллбара (для мыши и touch)
        scrollbar.addEventListener("mousedown", (e) => {
            if (e.target !== thumb) {
            moveScrollbar(e.clientX);
            }
        });
        scrollbar.addEventListener("touchstart", (e) => {
            if (e.target !== thumb) {
            const touch = e.touches[0];
            moveScrollbar(touch.clientX);
            }
        });

        // Обновляем thumb при прокрутке контейнера
        container.addEventListener("scroll", updateThumb);
        updateThumb();
        }



        // scroll comparison on mobile
    }
})();

// image comparison

// close bitrix24
(function () {
    window.addEventListener('load', () => {

        setTimeout(() => {
            const closeBtn = document.querySelector('.b24-widget-button-popup-btn-hide')
            if (!closeBtn) return;
            closeBtn.click()
        }, 5000);
    })
})();
// close bitrix24  

// cart toast
(function () {
  let cartToastTimeout;
  let cartToastDelayTimeout;

  const toastSelector = '.cart__toast';
  const closeBtnSelector = '.cart__toast_close';
  const visibleClass = 'cart__toast--visible';
  const sessionKey = 'cart_toast_closed';

  function showCartToast() {
    if (sessionStorage.getItem(sessionKey)) {
      return;
    }

    const toast = document.querySelector(toastSelector);
    if (!toast) {
      return;
    }

    // Показываем
    toast.classList.add(visibleClass);

    // Скрываем через 10 секунд
    cartToastTimeout = setTimeout(() => {
      hideCartToast();

      // Повторно показать через 15 секунд
      cartToastDelayTimeout = setTimeout(showCartToast, 15000);
    }, 10000);
  }

  function hideCartToast() {
    const toast = document.querySelector(toastSelector);
    if (!toast) return;
    toast.classList.remove(visibleClass);
  }

  function handleManualClose() {
    sessionStorage.setItem(sessionKey, 'true');
    hideCartToast();
    clearTimeout(cartToastTimeout);
    clearTimeout(cartToastDelayTimeout);
  }

  document.addEventListener('DOMContentLoaded', function () {
    const closeBtn = document.querySelector(closeBtnSelector);
    if (closeBtn) {
      closeBtn.addEventListener('click', handleManualClose);
    }

    setTimeout(() => {
      showCartToast();
    }, 2000);
  });
})();
// cart toast

// product options hover on mobile
(function () {
document.addEventListener('DOMContentLoaded', function () {
  const touchImages = document.querySelectorAll('.default_option img, .lip__item img');

  touchImages.forEach(img => {
    img.addEventListener('touchstart', () => {
      img.classList.add('tapped');

      setTimeout(() => {
        img.classList.remove('tapped');
      }, 1000);
    });
  });
});
})();
// product options hover on mobile

// toggle header car dropdown
(function () {
    document.addEventListener("click", function(e) {
        const trigger = e.target.closest(".header__car");
        const allDropdowns = document.querySelectorAll(".header__car_dropdown");

        // Клик по кнопке (открыть/закрыть)
        if (trigger) {
            const dropdown = trigger.nextElementSibling;

            // Закрываем все остальные
            allDropdowns.forEach(d => {
                if (d !== dropdown) d.classList.remove("active");
            });

            // Тогглим текущий
            dropdown.classList.toggle("active");
            return;
        }

        // Клик вне любых дропдаунов (закрыть всё)
        if (!e.target.closest(".header__car_dropdown")) {
            allDropdowns.forEach(d => d.classList.remove("active"));
        }
    });
})();
// toggle header car dropdown